import type { RejectionReason } from '../../../../../../apis/graphql';
import type { CreativesBuilderValues } from '../../../types';
import type { CreativeFooterAsset, CreativeFooterRejectedAsset, FooterCreativeData } from '../types';
import { CUSTOM_REJECTION_REASON } from './constants';

export const getReviewAlertData = (
  assets: Array<CreativeFooterAsset>,
  creative: CreativesBuilderValues,
  rejectionReasons: RejectionReason[]
): { rejectedAssets: CreativeFooterRejectedAsset[]; footerCreative: FooterCreativeData } => {
  const uniqueIssues: Set<string> = new Set();
  const rejectedAssets: CreativeFooterRejectedAsset[] = [];

  rejectionReasons.forEach((rejectionReason) => {
    const creativeBuilderAsset = assets.find((asset) => asset.id === rejectionReason.assetId);
    if (!creativeBuilderAsset) return;

    const assetRejectionReasons: string[] = [];
    rejectionReason.declines.forEach((decline) => {
      assetRejectionReasons.push(decline.reason);
      uniqueIssues.add(decline.reason);
    });

    if (assetRejectionReasons.length) {
      rejectedAssets.push({
        name: creativeBuilderAsset.name,
        id: creativeBuilderAsset.id,
        rejectionReasons: assetRejectionReasons,
      });
    }
  });

  const rejectionReasonDetails = Array.from(uniqueIssues);

  const creativeRejectionReason =
    rejectionReasonDetails.length > 1
      ? CUSTOM_REJECTION_REASON.multipleIssues
      : rejectionReasonDetails[0] || CUSTOM_REJECTION_REASON.unknownIssue;

  const footerCreative: FooterCreativeData = {
    id: creative.id,
    name: creative.name,
    rejectionReason: creativeRejectionReason,
    rejectionReasonDetails,
  };

  return { rejectedAssets, footerCreative };
};
